import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { UserService } from '../services/user.service';
import { DataSharingService } from '../services/data-sharing.service';
import { ContactUsService } from '../services/contactus.service';

import { CreateLogin } from '../models/create-login';
import { ContactRequest } from '../models/contact-request';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})

export class ForgotPasswordComponent implements OnInit {
  passwordRequest: ContactRequest = new ContactRequest();
  email = '';
  code = '';
  tempCode = '';
  password = '';
  confirmpass = '';
  phase = 1;
  msg = '';
  role = 1;
  passedOTPC = '';
  createLogin: CreateLogin = new CreateLogin();
  sending: boolean = false;
  displayModal: string = "none";

  constructor(
    private _router: Router,
    private _userService: UserService,
    private _dataService: DataSharingService,
    private route: ActivatedRoute,
    private _contactUsService: ContactUsService) {
      this.createLogin = new CreateLogin();
    }

  ngOnInit() {
     this.passedOTPC = this.route.snapshot.queryParamMap.get('OTPC');
    if (this.passedOTPC != null) {
      this.CheckOTPC(this.passedOTPC);
    }
  }

/*
  this.phase === 1 will ask for user's email
      A One-Time Pass Code will be send via email.
      The email will also contain a link which looks like this:
            http://localhost:4200/forgot-password?OTPC=${one-time passcode}
  this.phase === 2 will verify that OTPC is entered correctly, either
      if manually entered, or it came in on the link.
  this.phase === 3 allows user to enter new password.
*/

  submit() {
    // create a code
    if (this.phase === 1) {
      this.tempCode = this.makeOTPC();
      // window.sessionStorage.setItem('thisOTPC', this.tempCode);
      window.sessionStorage.setItem('thisEmail', this.email);
      this.sending = true;
      this._userService.saveVerification(this.email, this.tempCode)
        .subscribe(
        res => this.saveVerificationSuccess(res),
        error => this.saveVerificationFailed(error),
        () => console.log('Save Verification Success!'));
      return;
    }
    if (this.phase === 2) {
      this.CheckOTPC(this.code);
      return;
    }
    if (this.phase === 3) {
      if (!(this.createLogin.password.length > 7)) {
        this.msg = 'Passwords must be at least 8 characters long.';
        return;
      }
      if (!(this.createLogin.password === this.createLogin.confirmpass)) {
        this.msg = 'Passwords must match.';
        return;
      }
      this.email = window.sessionStorage.getItem('thisEmail');
      this._userService.UpdatePwdByEmail(this.email, this.createLogin.password)
        .subscribe(
          res => this.PasswordSuccessful(res),
          error => this.PasswordFailed(error),
          () => console.log('Success!'));
      this._userService.saveVerification(this.email, 'null')
        .subscribe(
        res => this.saveVerificationSuccess(res),
        error => this.saveVerificationFailed(error),
        () => console.log('Save Verification Success!'));
      return;
    }
  }

  // This is called both if OTPC came in via URL, and if it is manually entered in phase === 2
  CheckOTPC(OTPC: string) {
    if (OTPC.length !== 5) {
      this.phase = 2;
      return;
    }
    this.code = OTPC;
    this._userService.GetUserByOTPC(this.code)
      .subscribe(
        res => this.getByOTPCSuccess(res),
        error => this.getByOTPCFailed(error),
        () => console.log('Success!'));
    return;
  }

  getByOTPCSuccess(result: any) {
    this.email = result.current_user.email;
    this.role = result.current_user.roleId;
    window.sessionStorage.setItem('thisEmail', this.email);
    window.sessionStorage.setItem('thisRole', (this.role + ''));
    this.phase = 3;
    return;
  }

  getByOTPCFailed(res: any) {
    alert('One-Time Pass Code does not match or has expired.');
    this.phase = 2;
    return;
  }

  saveVerificationFailed(error: any) {
    this.sending = false;
    this.displayModal = 'block';
  }

  saveVerificationSuccess(res: any) {
    if (this.phase !== 3) {
      // AT THIS POINT, WE HAVE TO SEND THE EMAIL!!!!
      this.email = window.sessionStorage.getItem('thisEmail');
      this.passwordRequest = new ContactRequest();
      this.passwordRequest.name = this.tempCode;
      this.passwordRequest.phone = '999-999-9999';
      this.passwordRequest.email = this.email;
      this.passwordRequest.message = `forgot-password?OTPC=${this.tempCode}`;
      this.passwordRequest.subject = 'Password Change';
      this._contactUsService.sendContactRequest(this.passwordRequest)
        .subscribe(
        res => this.sendEmailSuccess(res),
        error => this.sendEmailFailed(error),
        () => {
          console.log('ContactRequest Sent!');
        });
    }
  }

  sendEmailSuccess(res: any) {
    this.phase = 2;
    this.sending = false;
    alert(`You should receive an email with a One-Time Pass Code. Enter it into the box below, or click on the link in the email.`);
  }
  sendEmailFailed(error: any) {
    this.sending = false;
  }

  PasswordFailed(error: any) {
    alert('Password reset failed. Please try again.');
    this.phase = 1;
  }

  PasswordSuccessful(res: any) {
    alert('Your password has been reset. Please log in with your new password.')
    this.role =  Number(window.sessionStorage.getItem('thisRole'));
    window.sessionStorage.removeItem('thisRole');
    window.sessionStorage.removeItem('thisEmail');
    if (this.role === 1 ) {
      this._router.navigate(['mhs-login']);
    } else {
      this._router.navigate(['staff-registration']);
    }
  }

  makeOTPC(): string {
    let outString = '';
    const inOptions = 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let i = 0; i < 5; i++) {
      outString += inOptions.charAt(Math.floor(Math.random() * inOptions.length));
    }
    return outString;
  }

  cancel() {
    this.displayModal = "none";
  }

  newAccount() {
    this.displayModal = "none";
  }
}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts